import { mapState } from 'vuex';
import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';

// @vue/component
export default {
  name: 'Success',
  components: {
    PageHeader,
  },
  data() {
    return {
      code: '',
    };
  },
  created() {
    this.code = this.$route.query.code;
  },
  computed: {
    ...mapState({
      // eslint-disable-next-line
      title: (state) => state.site.siteInfo.displayOptions.showSiteNameOnLoginScreen ? state.site.siteInfo.name : 'Log in',
    }),
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/Success/Success.js